module.exports = __webpack_public_path__ + "img/logo_utopia.1b4dc243.png";